<h4>{{title}}</h4>

<form
    id="interestsForm"
    name="interestsForm"
    novalidate
    autocomplete="off"
    data-test-automation="interests"
    #interestsForm="ngForm">
    <div>
        @if (showTenureInterestsNotifications()) {
            <tenure-interests-notifications [interestsUiConfig]="interestsUiConfig"></tenure-interests-notifications>
        }
        <new-interests-notifications
            [newInterestsQuestionDisplay]="newInterestsQuestionDisplay"
            [newInterestsUiConfig]="newInterestsUiConfig"></new-interests-notifications>
        <additional-interest-notification-questions></additional-interest-notification-questions>
        <div class="container-fluid">
            <div class="row buttons">
                <div class="button-group">
                    <button
                        id="saveInterestsPageBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        title="Save Interests page data | Ctrl+S"
                        (click)="save()"
                        [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || saveDisabled()"
                        data-test-automation="save-interests">
                        Save
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>

                    <button
                        id="validateInterestsPageBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        title="Validate Interests page data | V"
                        (click)="validate()"
                        [disabled]="(['EDIT_PLAN', 'VIEW_PLAN'] | disabledByPermissions) || validateDisabled()"
                        data-test-automation="validate-interests">
                        Validate
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>

                    <button
                        id="cancelInterestsPageBtn"
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="cancel()"
                        title="Clears all data on the Interests screen"
                        [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || readonly()"
                        data-test-automation="cancel-interests"
                        >Cancel</button
                    >
                </div>
            </div>
        </div>
    </div>
</form>
